export function ArcCoordinates(centerX, centerY, radius, radians) {
  return {
    x: centerX + radius * Math.cos(radians),
    y: centerY + radius * Math.sin(radians)
  };
}
